import { useSandboxProvider } from '../../hooks/providers';
import { ISandboxProvider } from '../../interfaces/service/SandboxServiceManagerInterface';
import { createContext } from 'react';

export const SandboxContextSM = createContext<ISandboxProvider>(
  {} as ISandboxProvider
);

export const SandboxProvider = (props: any) => {
  const sandbox = useSandboxProvider();
  return (
    <SandboxContextSM.Provider value={sandbox}>
      {props.children}
    </SandboxContextSM.Provider>
  );
};
